import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./component/ScrollToTop"; // Import ScrollToTop
import Header from "./component/Header";
import Home from "./component/Home";
import About from "./component/Aboutus";
import B2BStorefront from "./component/B2BStorefront";
import Blog from "./component/BlogPosts";
import Contact from "./component/Contactus";
import GlobalTrade from "./component/GlobalTrade";
import Training from "./component/Training";
import Wholesale from "./component/Wholesale";
import Footer from "./component/Footer";


const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop /> {/* Ensures scrolling to top on every navigation */}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/products" element={<B2BStorefront />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/global-trade" element={<GlobalTrade />} />
        <Route path="/training" element={<Training />} />
        <Route path="/Wholesale" element={<Wholesale />} />
    
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
